import type { StudentState } from '@evidia/shared';
import { ExamResult, STUDENT_GROUP_TEXT, StudentGroup, TrainingType, TrainingTypeExtended } from '@evidia/shared';

export const STUDENT_GROUP_LIST = [
	{ group: 'Osobní automobil a přívěs', value: STUDENT_GROUP_TEXT.B, key: StudentGroup.B },
	{ group: 'Osobní automobil a přívěs', value: STUDENT_GROUP_TEXT.Ba, key: StudentGroup.Ba },
	{ group: 'Osobní automobil a přívěs', value: STUDENT_GROUP_TEXT.B96, key: StudentGroup.B96 },
	{ group: 'Osobní automobil a přívěs', value: STUDENT_GROUP_TEXT.BpE, key: StudentGroup.BpE },
	//
	{ group: 'Motocykly', value: STUDENT_GROUP_TEXT.AM, key: StudentGroup.AM },
	{ group: 'Motocykly', value: STUDENT_GROUP_TEXT.A1, key: StudentGroup.A1 },
	{ group: 'Motocykly', value: STUDENT_GROUP_TEXT.A2, key: StudentGroup.A2 },
	{ group: 'Motocykly', value: STUDENT_GROUP_TEXT.A, key: StudentGroup.A },
	//
	{ group: 'Nákladní vozidla, autobus, traktor', value: STUDENT_GROUP_TEXT.C, key: StudentGroup.C },
	{ group: 'Nákladní vozidla, autobus, traktor', value: STUDENT_GROUP_TEXT.CpE, key: StudentGroup.CpE },
	{ group: 'Nákladní vozidla, autobus, traktor', value: STUDENT_GROUP_TEXT.D, key: StudentGroup.D },
	{ group: 'Nákladní vozidla, autobus, traktor', value: STUDENT_GROUP_TEXT.DpE, key: StudentGroup.DpE },
	{ group: 'Nákladní vozidla, autobus, traktor', value: STUDENT_GROUP_TEXT.T, key: StudentGroup.T },
	//
	{ group: 'Ostatní', value: STUDENT_GROUP_TEXT.C1, key: StudentGroup.C1 },
	{ group: 'Ostatní', value: STUDENT_GROUP_TEXT.C1pE, key: StudentGroup.C1pE },
	{ group: 'Ostatní', value: STUDENT_GROUP_TEXT.D1, key: StudentGroup.D1 },
	{ group: 'Ostatní', value: STUDENT_GROUP_TEXT.D1pE, key: StudentGroup.D1pE },
	{ group: 'Ostatní', value: STUDENT_GROUP_TEXT.B1, key: StudentGroup.B1 },
];

export const TRAINING_TYPES_TEXT: Record<TrainingType, string> = {
	ASSOCIATED: 'Sdružený',
	BASIC: 'Základní',
	COMPLEMENTARY: 'Doplňovací',
	EXPANDING: 'Rozšiřující',
};

export const TRAINING_TYPES_LIST = [
	{ value: TRAINING_TYPES_TEXT.BASIC, key: TrainingType.BASIC },
	{ value: TRAINING_TYPES_TEXT.EXPANDING, key: TrainingType.EXPANDING },
	{ value: TRAINING_TYPES_TEXT.ASSOCIATED, key: TrainingType.ASSOCIATED },
	{ value: TRAINING_TYPES_TEXT.COMPLEMENTARY, key: TrainingType.COMPLEMENTARY },
];

export const TRAINING_EXTENDED_TYPES_TEXT: Record<TrainingTypeExtended, string> = {
	COURSE: 'Kurz',
	ISP: 'Individuální (ISP)',
	VRP: 'VŘP',
};

export const TRAINING_EXTENDED_TYPES_LIST = [
	{ value: TRAINING_EXTENDED_TYPES_TEXT.ISP, key: TrainingTypeExtended.ISP },
	{ value: TRAINING_EXTENDED_TYPES_TEXT.COURSE, key: TrainingTypeExtended.COURSE },
	{ value: TRAINING_EXTENDED_TYPES_TEXT.VRP, key: TrainingTypeExtended.VRP },
];

export const STUDENT_STATE_TEXT: Record<StudentState, string> = {
	EXAM_CORRECTION: 'Oprava',
	FINISHED: 'Ukončen',
	IN_PROGRESS: 'Probíhající',
	NOT_STARTED: 'Nezahájen',
	TO_EXAM: 'Ke zkouškám',
	STORNO: 'Stornován',
	DONE: 'Absolvován',
	WAITING_FOR_ADMISSION: 'Čeká na přijetí',
};

export const EXAM_RESULT_TEXT: Record<ExamResult, string> = {
	[ExamResult.SUCCESS]: 'Prospěl',
	[ExamResult.FAIL]: 'Neprospěl',
	[ExamResult.DID_NOT_TAKE_PLACE]: 'Nekonalo se',
};
